<template>
  <div class="package-summary">
    <accordion-block
      panel
      visible
      :title="'Riepilogo della tua prenotazione'"
      :collapse_id="'package-summary__accordion'"
    >
      <hr class="package-summary__divider package-summary__divider--top" />

      <services
        class="package-summary__services"
        :services="services"
        flat
      />
      <services-insurance
        class="package-summary__insurance"
        :flight_and_stay="has_flights"
        flat
      />

      <hr class="package-summary__divider" />

      <p class="package-summary__note">
        Il prezzo che vedi è già comprensivo delle riduzioni o eventuali
        gratuità previste per i bambini.
      </p>
      <p v-if="has_flights" class="package-summary__footnote">
        <strong>* I trasferimenti potrebbero non essere sempre inclusi.</strong>
        Per maggiori dettagli, verifica le informazioni presenti nel pacchetto
        scelto o contatta la nostra assistenza.
      </p>

      <hr class="package-summary__divider" />

      <div class="package-summary__pricing">
        <div class="package-summary__pricing-amount">
          <insufficient-credit-alert
            :availability="availability"
            :total_price="live_price"
            class_name="package-summary__nocredit"
            icon_class_name="package-summary__nocredit-icon ml-1"
            cta_id="alpitour-quote-insufficient-credit"
          />
          <span class="package-summary__pricing-display">
            &euro; {{ live_price }}
          </span>
          <span v-if="price_per_pax" class="package-summary__pricing-perpax">
            (&euro; {{ price_per_pax }}/pers.)
          </span>
        </div>
        <span class="package-summary__pricing-updated">
          Attenzione, il prezzo della tua soluzione è stato aggiornato.
        </span>
      </div>
    </accordion-block>
  </div>
</template>

<script>
import { has_flights, price_per_person } from "@alpitour/utilities";
import AccordionBlock from "@alpitour/components/blocks/detail/accordion-block.vue";
import Services from "@alpitour/components/blocks/services.vue";
import ServicesInsurance from "@alpitour/components/blocks/detail/assicurazione-medico-bagaglio.vue";
import InsufficientCreditAlert from '@alpitour/components/atoms/insufficient-credit-alert.vue'

export default {
  name: "package-summary",
  components: {
    "accordion-block": AccordionBlock,
    services: Services,
    "services-insurance": ServicesInsurance,
    "insufficient-credit-alert": InsufficientCreditAlert,
  },
  props: {
    services: {
      type: Object,
      default: () => ({}),
    },
    live_price: {
      type: Number,
      default: 0,
    },
    availability: {
      type: Object,
      default: () => ({}),
    },
    pax_count: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    has_flights() {
      return has_flights(this.services);
    },
    price_per_pax() {
      return price_per_person(this.live_price, this.pax_count);
    },
  },
};
</script>

<style lang="scss" scoped>
.package-summary {
  &__services {
    margin-bottom: $grid-gutter-width;
  }

  &__divider {
    border: 0;
    border-top: 1px solid $gray-200;
    margin: $grid-gutter-20 0;

    &--top {
      margin-top: 0;
    }
  }

  &__note {
    margin-bottom: 0;
  }

  &__footnote {
    margin-top: $grid-gutter-width / 3;
    margin-bottom: 0;

    strong {
      color: var(--info);
      font-weight: $vb-font-weight-semibold;
    }
  }

  &__pricing-amount {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: $grid-gutter-width / 3;
  }

  &__pricing-display {
    color: $vb-body-color;
    font-size: $font-size-lg;
    font-weight: $vb-font-weight-semibold;
    line-height: normal;
  }

  &__pricing-perpax {
    color: $gray-600;
    font-style: italic;
    font-size: $font-size-md;
  }

  &__pricing-updated {
    display: block;
    text-align: right;
    color: $secondary;
  }

  ::v-deep {
    .insufficient-credit-alert {
      display: inline-block;
      font-size: $font-size-md;
    }
  }

  &__nocredit-icon {
    margin-left: 0.25rem;
  }
}
</style>
